import { useEffect } from "react"
import { useSignal } from "@preact/signals-react"
import {getSubmit, postSubmit} from "@ui-seeker/utils"

import {customerID} from "@signals";
import { BACKEND_APIS } from "@constants"
import { useToast } from "@hooks"


export default function useProductPageImageDetailsCatalogue(rowData) {
    const isLoadingCatalogue = useSignal(false)
    const catalogueData = useSignal([])
    const { showToast } = useToast()

    useEffect(() => {
        const images = rowData.catalogueImagesData ?? []
        catalogueData.value = images
        if (!images.length)
            showToast.warning(`No catalog images available for the selected SKU`)
    }, [rowData])

    return {
        catalogueData: catalogueData.value,
        isLoadingCatalogue: isLoadingCatalogue.value
    }
}